export default __webpack_public_path__ + "assets/advice_desktop.png";